import React from 'react'

const UnexpectedErrorPage = () => {
  return (
    <>
      <section className="" id="">
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div className="container">
            <div className="row text-center">
              <div className="col-sm-12">
                <h1>
                  ¡Ups! Algo salió mal. <i className="fas fa-plug"></i>
                </h1>
                <p className="last-p">
                  Lo sentimos, ha ocurrido un error inesperado.
                </p>
                <img src="/logo192.png" alt="Error en la página" />
              </div>
              <div className='d-flex justify-content-center'>
                <button className="settings_button-pleno bg-p-secondary mt-3" onClick={() => window.location.reload()}>
                  Recargar Pagina
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default UnexpectedErrorPage;
